import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function SyteflowPrivacy() {
  return (
    <div style={{ background: 'white'}}>
      <Container
        id="syteflowprivacy"
        sx={{
          py: { sm: 8, xs: 6 },
          color: 'black',
        }}
        fixed
      >
        <Typography variant="h4" gutterBottom>
          Syteflow Privacy Policy
        </Typography>
        <Typography variant="body2" gutterBottom>
          Last updated: May 19, 2025
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Introduction
        </Typography>
        <Typography variant="body1">
          Syteflow (“we”, “us”, “our”) is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application (Syteflow).
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Data We Collect
        </Typography>
        <Typography variant="body1" component="div" paragraph>
          <ul>
            <li>
              <strong>Account Information</strong>: Name, Photo, phone number of labourers, contractors and suppliers.
            </li>
            <li>
              <strong>Site & Inventory Data</strong>: Construction site details, inventory items, and stock levels.
            </li>
            <li>
              <strong>Attendance & Payments</strong>: Timestamps for labor attendance and offline payment records (amount, date, payer/payee).
            </li>
          </ul>
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. How We Use Your Data
        </Typography>
        <Typography variant="body1">
          We use your login credentials data to authenticate and manage user access, record and display attendance, inventory, and payment histories, generate reports for your clients, provide customer support.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Data Sharing & Disclosure
        </Typography>
        <Typography variant="body1" component="div">
          <ul>
            <li>We do <strong>not</strong> sell or rent your personal data.</li>
            <li>We may share data with:
              <ul>
                <li><strong>Service Providers</strong> (e.g., hosting, analytics) under strict confidentiality.</li>
                <li><strong>Legal authorities</strong>, if required by law or to protect our rights.</li>
              </ul>
            </li>
          </ul>
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Data Retention
        </Typography>
        <Typography variant="body1">
          We retain your data for as long as your account is active or as needed to provide you services, and thereafter in accordance with legal requirements.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Security
        </Typography>
        <Typography variant="body1">
          We implement reasonable technical and organizational measures (encryption, access controls) to protect your data.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          Depending on your jurisdiction, you may have the right to access, correct, or delete your personal data. Contact us at <a 
            href="mailto:contact@aliatis.io"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "mailto:contact@aliatis.io";
            }}
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >contact@aliatis.io</a> for any requests.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. Children’s Privacy
        </Typography>
        <Typography variant="body1">
        Our App is publicly accessible for download and is marked as suitable for users aged 4 and older in the app store. However, the App is intended solely for use by pre-registered clients who are onboarded through our client onboarding process. Without onboarding and login credentials, users cannot access or use the App’s features.
        <br /><br />
        We do not knowingly collect personal information from children under the age of 16 (or the minimum age required by applicable law), and no data is collected from users who are not authenticated. If we become aware that we have inadvertently collected personal information from a child, we will promptly delete such data. Parents or guardians who believe their child has interacted with the App inappropriately or provided information may contact us for assistance.
        </Typography>

        <Typography variant="h6" gutterBottom>
          9. Changes to This Policy
        </Typography>
        <Typography variant="body1">
          We may update this policy; we’ll post any changes here with a revised "Last updated" date.
        </Typography>

        <Typography variant="h6" gutterBottom>
          10. Contact Us
        </Typography>
        <Typography variant="body1">
          If you have questions, email: <a 
            href="mailto:contact@aliatis.io"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "mailto:contact@aliatis.io";
            }}
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >contact@aliatis.io</a><br />
          Visit: <a href="https://www.aliatis.io/products/syteflow/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>https://www.aliatis.io/products/syteflow/privacy-policy</a>
        </Typography>
      </Container>
    </div>
  );
}
